import { getFontUrl } from '@/utils/imageUrls/getFontUrl';
import { getRequest } from './methods/getRequest';

export const fetchFont = (fontFamilyId: string, fontId: string) =>
  getRequest(getFontUrl(fontFamilyId, fontId)).then((response) => response.arrayBuffer());
